import Http from "../Http/Http";
import Token from "../Token/Token";
import Storage from "../Storage/Storage";
import { AxiosPromise } from "axios";
import TokenActions from "../Action/Actions/TokenActions";
import {browserHistory} from "react-router";

class Auth {

  public getSession(token: string): AxiosPromise {
    return Http.setBearer(token)
    .then(() => {
      return Http.get("session");
    })
    .then(res => {
      const user = res.data.data;
      return user;
    });
  }

  public signup(data): AxiosPromise {
    return Http.post("auth/signup", data)
    //We decide to not register user and start app, instead only present dialog for user with instruction to set password and confrim email, and than start app.
    // .then(res => {
    //   const user = res.data.data;
    //   return user;
    // })
    // .then(user => {
    //   return Token.set(user.token)
    //   .then(() => {
    //     return user;
    //   });
    // });
  }

  public signin(id, password, agencyId, email): AxiosPromise {
    const data = {
      userId: id,
      password: password,
      agencyId: agencyId,
      email: email
    };

    return Http.post("auth/signin", data)
    .then(res => {
      const user = res.data.data;
      return user;
    })
    .then(user => {
      return Token.set(user.token)
      .then(() => {
        return user;
      });
    });
  }

  public signout(): Promise<any> {
    return new Promise(accept => {
      TokenActions.update("");
      Storage.clear();
      return accept();
    });
  }

  public signoutRedirect(): Promise<any> {
    return new Promise(accept => {
      browserHistory.push("/auth/check-email");
      return accept();
    });
  }

  public checkEmail(email: string): AxiosPromise {
    return Http.post("auth/check-email", {
      email: email
    })
    .then(res => {
      const user = res.data.data;
      return user;
    });
  }

  public forgotPassword(user): AxiosPromise {
    return Http.post("auth/forgot-password", {
      userId: user.id
    });
  }

  public resendConfirmationMail(user): AxiosPromise {
    let userId: number;

    if (typeof user.data.id === "undefined") {
      userId = user.data;
    } else {
      userId = user.data.id;
    }

    return Http.post("auth/resend-confirm", {
      userId: userId
    });
  }

  public resendInviteMail(user): AxiosPromise {
    let userId: number;

    if (typeof user.data.id === "undefined") {
      userId = user.data;
    } else {
      userId = user.data.id;
    }

    return Http.post("auth/resend-invite", {
      userId: userId
    });
  }

  public confirmAccount(data): AxiosPromise {
    return Http.post("auth/confirm-account", data)
    .then(res => {
      const user = res.data.data;
      return user;
    })
    .then(user => {
      return Token.set(user.token)
      .then(() => {
        return user;
      });
    });
  }

  public resetPassword(data): AxiosPromise {
    return Http.post("auth/reset-password", data)
    .then(res => {
      const user = res.data.data;
      return user;
    })
    .then(user => {
      return Token.set(user.token)
      .then(() => {
        return user;
      });
    });
  }
}

export default new Auth();
